import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'privacy',
    templateUrl: './privacy-policy.component.html',
    standalone: false
})
export class PrivacyPolicyComponent {
  constructor(private titleService: Title)
  {
    titleService.setTitle("SGC Grading Privacy Notice");
  }
}
